import { SceneNode } from '../engine/core/SceneNode';
import { Box3 } from 'three';

export type UpdateCallback = (deltaTime: number) => void;

export class UIUpdateManager extends SceneNode {
    public static instance: UIUpdateManager | null = null;
    private callbacks: Map<string, UpdateCallback> = new Map();
    private throttleInterval: number = 0.2; // 200ms in seconds
    private timeSinceLastUpdate: number = 0;

    constructor() {
        super('UIUpdateManager');
        if (UIUpdateManager.instance) {
            console.warn("UIUpdateManager instance already exists. Overwriting.");
        }
        UIUpdateManager.instance = this;
    }

    public register(id: string, callback: UpdateCallback): void {
        this.callbacks.set(id, callback);
    }

    public unregister(id: string): void {
        this.callbacks.delete(id);
    }

    protected onUpdate(deltaTime: number): void {
        this.timeSinceLastUpdate += deltaTime;

        if (this.timeSinceLastUpdate >= this.throttleInterval) {
            // This is called automatically by the Scene's update loop
            for (const callback of this.callbacks.values()) {
                callback(deltaTime);
            }
            this.timeSinceLastUpdate = 0;
        }
    }

    protected onDispose(): void {
        this.callbacks.clear();
        UIUpdateManager.instance = null;
    }

    public calculateBoundingBox(): Box3 {
        // This node has no visual representation, so return an empty THREE.Box3.
        return new Box3();
    }
} 